<app-modal-header
  [title]="title"
  (closeModal)="closeModal()"
></app-modal-header>

<div class="">
  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="data?.aspectRatioX / data?.aspectRatioY"
    format="png"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded($event)"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"
  ></image-cropper>
  <app-save-area
    saveText="Crop"
    [saveIcon]="'crop'"
    [showCancel]="false"
    [confirmFirst]="false"
    (save)="cropImage()"
  ></app-save-area>
</div>
